import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

// Shared "How the Device System Activity Log Works" trigger + modal,
// dropped into both the embedded panel on the Device Details page and the
// standalone Device System Activity Log page. Content is traced against
// the device-side packet-handling code (tcu4g_ota) that actually writes
// these log entries, plus the Device State Config / Device VIN Config
// pages whose changes only show up here indirectly - see the panel's own
// content for the full walkthrough.
@Component({
  selector: 'app-system-activity-log-info',
  standalone: true,
  imports: [MatIcon, MatTooltip],
  templateUrl: './system-activity-log-info.component.html',
  styleUrl: './system-activity-log-info.component.scss',
})
export class SystemActivityLogInfoComponent {
  isOpen = false;

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  // See fota-info.component.ts for why window.print() (not a PDF library).
  exportPdf(): void {
    window.print();
  }
}
